import { LinkButton, UIHeading1, UIHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SuburbanBlackFridayBanner.css';

interface ISuburbanBlackFridayBannerProps {
  link: string;
}

export const SuburbanBlackFridayBanner: React.FC<ISuburbanBlackFridayBannerProps> = ({ link }) => {
  return (
    <div className={styles['bf-banner']}>
      <div className={styles['title']}>
        <UIHeading1 color="white_100" fontWeight="700">
          Чёрная пятница 24-28 ноября
        </UIHeading1>
      </div>
      <div className={styles['subtitle']}>
        <UIHeading4 color="white_100" fontWeight="700">
          Эксклюзивные скидки на дома и участки от застройщиков
        </UIHeading4>
      </div>
      <LinkButton theme="fill_white_primary" href={link} target="_blank">
        Подробнее
      </LinkButton>
    </div>
  );
};
